import React from "react";
import leftArrow from "../../assets/leftArrow.svg";
import Card from "../../components/_edit_card/Card/Card";
import Layout from "../../shared/Layout/Layout";
import styles from "./EditCard.module.scss";

const EditCard = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>
          <h1>Edit Card</h1>
          <Card />
        </div>
      </div>
    </Layout>
  );
};

export default EditCard;
